/*                                                          */
export const noop = (() => { });
